var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "boas-vindas-falada",
      class: _vm.classesDaMoldura,
      attrs: {
        role: "region",
        "aria-label": _vm.copy.ARIA,
        "data-test": "boas-vindas-falada"
      }
    },
    [
      _vm.temAoVivo
        ? _c("video", {
            ref: "video",
            staticClass: "boas-vindas-falada__ao-vivo d-block mb-4",
            attrs: {
              autoplay: "",
              muted: "",
              playsinline: "",
              "data-test": "boas-vindas-ao-vivo"
            },
            domProps: { muted: true }
          })
        : _vm.mostrarClipe
        ? _c("video", {
            staticClass: "boas-vindas-falada__midia d-block mb-4",
            attrs: {
              src: _vm.clipeEfetivo,
              autoplay: "",
              muted: "",
              loop: "",
              playsinline: "",
              "data-test": "boas-vindas-clipe"
            },
            domProps: { muted: true }
          })
        : _vm.temRetrato
        ? _c("img", {
            staticClass: "boas-vindas-falada__midia d-block mb-4",
            attrs: {
              src: _vm.retrato,
              alt: _vm.copy.ARIA_RETRATO,
              "data-test": "boas-vindas-retrato"
            }
          })
        : _vm._e(),
      _vm.temAoVivo
        ? _c("audio", {
            ref: "audio",
            attrs: { autoplay: "", "data-test": "boas-vindas-audio-da-sala" }
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "boas-vindas-falada__roteiro",
          attrs: { "aria-live": "polite", "data-test": "boas-vindas-roteiro" }
        },
        [
          _vm.saudacaoDoRoteiro
            ? _c(
                "p",
                {
                  staticClass:
                    "boas-vindas-falada__bloco boas-vindas-falada__saudacao ia-texto-hero mb-4",
                  class: {
                    "boas-vindas-falada__bloco--ativo":
                      _vm.saudacaoDoRoteiro.ativo
                  },
                  attrs: {
                    "data-ativo": _vm.saudacaoDoRoteiro.dataAtivo,
                    "data-test": "boas-vindas-bloco"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.saudacaoDoRoteiro.texto) + " ")]
              )
            : _vm._e(),
          _vm._l(_vm.paragrafosDoRoteiro, function(item) {
            return _c(
              "p",
              {
                key: item.indice,
                staticClass:
                  "boas-vindas-falada__bloco boas-vindas-falada__paragrafo az-text-primary az-size-14 mb-4",
                class: { "boas-vindas-falada__bloco--ativo": item.ativo },
                attrs: {
                  "data-ativo": item.dataAtivo,
                  "data-test": "boas-vindas-bloco"
                }
              },
              [_vm._v(" " + _vm._s(item.texto) + " ")]
            )
          }),
          _vm.rotuloDosPassos
            ? _c(
                "p",
                {
                  staticClass: "boas-vindas-falada__bloco az-ds-label mb-3",
                  class: {
                    "boas-vindas-falada__bloco--ativo":
                      _vm.rotuloDosPassos.ativo
                  },
                  attrs: {
                    "data-ativo": _vm.rotuloDosPassos.dataAtivo,
                    "data-test": "boas-vindas-bloco"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.rotuloDosPassos.texto) + " ")]
              )
            : _vm._e(),
          _vm.passosDoRoteiro.length
            ? _c(
                "div",
                { staticClass: "boas-vindas-falada__passos az-gap" },
                _vm._l(_vm.passosDoRoteiro, function(item) {
                  return _c(
                    "div",
                    {
                      key: item.indice,
                      staticClass:
                        "boas-vindas-falada__bloco boas-vindas-falada__passo px-4",
                      class: { "boas-vindas-falada__bloco--ativo": item.ativo },
                      attrs: {
                        "data-ativo": item.dataAtivo,
                        "data-test": "boas-vindas-bloco"
                      }
                    },
                    [_c("BoasVindasPasso", { attrs: { passo: item.passo } })],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
          _vm.linhasDoRodape.length
            ? _c("div", {
                staticClass: "boas-vindas-falada__divisoria mt-6 mb-4"
              })
            : _vm._e(),
          _vm._l(_vm.linhasDoRodape, function(item) {
            return _c(
              "p",
              {
                key: item.indice,
                staticClass:
                  "boas-vindas-falada__bloco boas-vindas-falada__linha az-text-primary az-size-14 mb-2",
                class: { "boas-vindas-falada__bloco--ativo": item.ativo },
                attrs: {
                  "data-ativo": item.dataAtivo,
                  "data-test": "boas-vindas-bloco"
                }
              },
              [
                _c("span", {
                  staticClass: "boas-vindas-falada__marcador mt-2 mr-2",
                  attrs: { "aria-hidden": "true" }
                }),
                item.destino
                  ? _c(
                      "span",
                      [
                        _vm._v(_vm._s(item.antes)),
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: item.destino,
                              "data-test": "boas-vindas-link-creditos"
                            }
                          },
                          [_vm._v(_vm._s(item.link))]
                        ),
                        _vm._v(_vm._s(item.depois))
                      ],
                      1
                    )
                  : _c("span", [_vm._v(_vm._s(item.texto))])
              ]
            )
          }),
          _vm.fechamentoDoRoteiro || _vm.mostrarBotaoDeAvancar
            ? _c(
                "div",
                {
                  staticClass:
                    "boas-vindas-falada__fecho d-flex flex-wrap align-end az-gap mt-8"
                },
                [
                  _vm.fechamentoDoRoteiro
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "boas-vindas-falada__bloco boas-vindas-falada__fechamento az-text-primary az-size-14 mb-0",
                          class: {
                            "boas-vindas-falada__bloco--ativo":
                              _vm.fechamentoDoRoteiro.ativo
                          },
                          attrs: {
                            "data-ativo": _vm.fechamentoDoRoteiro.dataAtivo,
                            "data-test": "boas-vindas-bloco"
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.fechamentoDoRoteiro.texto) + " "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.mostrarBotaoDeAvancar
                    ? _c(
                        "BaseButton",
                        {
                          staticClass: "ml-auto flex-shrink-0",
                          attrs: {
                            primary: "",
                            "fit-content": "",
                            "data-test": "boas-vindas-avancar"
                          },
                          on: { click: _vm.avancar }
                        },
                        [_vm._v(" " + _vm._s(_vm.copy.AVANCAR) + " ")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm.mostrarRodape
        ? _c(
            "footer",
            {
              staticClass:
                "boas-vindas-falada__acoes d-flex align-center az-gap mt-4"
            },
            [
              _vm.mostrarBotaoDeFala
                ? _c(
                    "BaseButton",
                    {
                      attrs: {
                        outline: "",
                        "fit-content": "",
                        loading: _vm.preparando,
                        "data-test": "boas-vindas-ouvir"
                      },
                      on: { click: _vm.alternarFala }
                    },
                    [_vm._v(" " + _vm._s(_vm.rotuloDaFala) + " ")]
                  )
                : _vm._e(),
              _vm.mostrarMarcaDeEntregue
                ? _c(
                    "span",
                    {
                      staticClass:
                        "boas-vindas-falada__entregue d-flex align-center az-gap-small az-ds-aux",
                      attrs: { "data-test": "boas-vindas-entregue" }
                    },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "check-circle",
                          size: 14,
                          color: "var(--primary)"
                        }
                      }),
                      _vm._v(" " + _vm._s(_vm.copy.ENTREGUE) + " ")
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-fade-transition", [
                _vm.aviso
                  ? _c(
                      "span",
                      {
                        staticClass: "az-ds-aux",
                        attrs: {
                          role: "status",
                          "data-test": "boas-vindas-aviso"
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.aviso) + " ")]
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }